import { render } from "./people.vue?vue&type=template&id=4f12030a&scoped=true"
import script from "./people.vue?vue&type=script&lang=js"
export * from "./people.vue?vue&type=script&lang=js"

import "./people.vue?vue&type=style&index=0&id=4f12030a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f12030a"]])

export default __exports__